export const LOAD_STORES = 'APP/SELECT_STORE/LOAD_STORES'
export const LOAD_STORES_SUCCESS =
  'APP/SELECT_STORE/LOAD_STORES_SUCCESS'
export const LOAD_STORES_ERROR = 'APP/SELECT_STORE/LOAD_STORES_ERROR'

export const LOAD_STORES_CLEAN_UP = 'APP/SELECT_STORE/CLEAN_UP'
